import { type ReactNode } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '@/shared/auth/useAuth';
import { useAuthStore } from '@/shared/auth/useAuthStore';

type Props = { children: ReactNode };

export function ProtectedRoute({ children }: Props) {
  const { isAuthenticated, login } = useAuth();
  const hydrated = useAuthStore((s) => s._hydrated);

  // Wait for the store to rehydrate before making a redirect decision
  if (!hydrated) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'background.default' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    login();
    return null;
  }

  return <>{children}</>;
}
